export default {
  app: {
    privacy: {
      policy: 'personvernerklæring',
      expansive: 'Ved å bruke Expansive godtar du Expansive {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Økten har utløpt',
    sessionExpiredDescription:
      'Økten din har utløpt. Vennligst logg inn igjen for å fortsette å bruke applikasjonen.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Velg språk',
      chooseLanguageDescription:
        'Velg ditt foretrukne språk for applikasjonen. Dette vil endre språket på grensesnittet og innholdet.',
    },
    userSelection: {
      cancel: 'Avbryt',
      createNewUser: 'Navnet deres er ikke oppført',
      newUser: 'Ny bruker',
      selectAnExistingUser: 'Velg en eksisterende bruker',
      selectUserHint: 'Velg en eksisterende bruker eller opprett en ny for å fortsette.',
      startTypingToSearch: 'Begynn å skrive...',
    },
    verification: {
      codeVerification: {
        continue: 'Fortsett',
        header: 'Skriv inn stedstilgangskode',
        invalidCode: 'Ugyldig kode, vennligst prøv igjen.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Fortsett uten å verifisere posisjon',
        enterSiteAccessCode: 'Skriv inn stedstilgangskode',
        locationNotEnabledOrAvailable: 'Hvorfor ser jeg dette?',
        notAvailable: {
          description: 'GPS-posisjon støttes ikke på denne enheten.',
          header: 'Posisjon støttes ikke',
        },
        notEnabled: {
          description: 'Posisjonstjenester er ikke aktivert eller tillatelse er ikke gitt.',
          header: 'Posisjon ikke aktivert',
        },
        notVerified: {
          description: 'GPS indikerer at du ikke er på stedet.',
          header: 'Posisjon ikke verifisert',
        },
        tryAgain: 'Prøv igjen',
        unavailable: {
          description: 'Vi kunne ikke verifisere GPS-posisjonen din.',
          header: 'Posisjon utilgjengelig',
        },
        unknown: {
          description: 'Vi klarer ikke å fastslå posisjonen din.',
          header: 'Ukjent posisjon',
        },
        verified: {
          description: 'GPS indikerer at du er på stedet.',
          header: 'Posisjon verifisert',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Ingen eiendeler funnet',
        emptyDescription: 'Det er ingen eiendeler knyttet til denne arbeidsordren.',
        warrantyParts: 'Deler med garanti utløper',
        serialNumber: 'Serienummer',
        none: '<ingen>',
      },
      updates: {
        emptyTitle: 'Ingen oppdateringer funnet',
        emptyDescription: 'Det er ingen oppdateringer for denne arbeidsordren.',
        unknownUser: 'Ukjent bruker',
        none: 'Ingen',
        addComment: {
          buttonLabel: 'Legg til kommentar',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Farlige forhold',
          no: 'Nei',
          yes: 'Ja',
        },
      },
    },
    attachmentsList: {
      attachments: 'Vedlegg',
      documents: 'Dokumenter',
      siteDocuments: 'Stedsdokumenter',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Farlige forhold',
        induction: 'Introduksjon',
        safeToProceed: 'Sikkert å fortsette',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Forfallsdato',
        activeSessions: 'Aktive økter',
        activeSessionsDescription:
          'Du er allerede sjekket inn på følgende arbeidsordrer. Du må sjekke ut fra disse arbeidsordrene før du kan sjekke inn på en ny arbeidsordre.',
        resumeSession: 'Gjenoppta',
        startTime: 'Startet kl',
        unexpectedErrorTitle: 'Uventet feil',
        unexpectedErrorMessage:
          'En uventet feil oppstod under oppretting av øktene dine. Vennligst prøv igjen senere.',
        engineerNotFound: 'Ingeniør ikke funnet',
        engineerNotFoundDescription:
          'Ingeniøren du prøver å sjekke inn, ble ikke funnet i systemet. Vennligst kontakt administratoren din.',
      },
      verification: {
        code: {
          description:
            'For å sjekke inn, vennligst skaff den 4-sifrede koden fra stedets leder eller utpekt kontaktperson.',
        },
        geo: {
          continue: 'Fortsett',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Vennligst få tilgangskoden fra stedets leder eller utpekt kontaktperson for å fullføre besøket ditt.',
            checkOut: 'Sjekk ut',
            completeBeforeLeaving: 'Vennligst fyll ut følgende skjema før du forlater.',
            continue: 'Fortsett',
            noResolutionSelected: 'Vennligst velg en løsning før du fortsetter.',
            quoteRequired: {
              hint: 'Besøk fullført, tilbud kommer',
              label: 'Tilbud kreves',
            },
            returnVisitRequired: {
              hint: 'Vi kommer tilbake igjen for å fullføre',
              label: 'Tilbakevisitt kreves',
            },
            serviceCompleted: {
              hint: 'Ingen videre tiltak kreves',
              label: 'Tjeneste fullført',
            },
            uploadCheckout: 'Last opp en fil, foto eller video',
            visitNotes: 'Besøksnotater',
            workOrderResolution: 'Løsning på arbeidsordre',
            enterNotes: 'Skriv inn eventuelle notater her...',
            errors: {
              timedOut: 'Tidsavbrudd, over 30 sekunder. Vennligst prøv igjen.',
              closingSession: 'Feil ved avslutning av økt',
            },
          },
          success: {
            description:
              'Takk for besøket på {site}. | {site} har fortsatt 1 åpen arbeidsordre. | {site} har fortsatt {count} åpne arbeidsordrer.',
            endVisit: 'Avslutt besøk',
            header: 'Du har blitt sjekket ut',
            viewWorkOrders: 'Sjekk inn på en annen arbeidsordre',
          },
          verification: {
            code: {
              description:
                'For å sjekke ut, vennligst skaff den 4-sifrede koden fra stedets leder eller utpekt kontaktperson.',
              continue: 'Fortsett',
            },
            geo: {
              checkOut: 'Sjekk ut',
              continue: 'Fortsett',
            },
          },
        },
        detail: {
          assets: 'Eiendeler',
          call: 'Ring',
          checkOut: 'Sjekk ut',
          closed: 'Lukket',
          details: 'Detaljer',
          dueBy: 'Forfallsdato',
          manageEngineers: 'Administrer ingeniører',
          notAvailable: 'Ikke tilgjengelig',
          pointOfContact: 'Kontaktperson',
          siteAccessTimes: 'Tilgangstider til stedet',
          siteAccessInstructions: 'Tilgangsinstruksjoner',
          siteAddress: 'Stedadresse',
          siteNotes: 'Stednotater',
          siteTelephone: 'Stedstelefon',
          siteLocation: 'Stedsplassering',
          updates: 'Oppdateringer',
          more: 'Mer',
          mismatchErrorTitle: 'Feil i arbeidsordre',
          mismatchErrorMessage:
            'Arbeidsordren du prøver å få tilgang til, samsvarer ikke med den du for øyeblikket er sjekket inn på. Vennligst sjekk arbeidsordren din og prøv igjen.',
          siteDocuments: 'Stedsdokumenter',
          validFrom: 'Gyldig fra',
          validUntil: 'Gyldig til',
          documentName: 'Dokumentnavn',
          documentType: 'Dokumenttype',
          attachments: 'Filer til arbeidsordre',
          download: 'Last ned',
          workDetails: 'Arbeidsdetaljer',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Legg til assistentingeniør',
            assistantEngineers: 'Assistentingeniører',
            description:
              'Av sikkerhetsgrunner, vennligst spesifiser navnene på hver ingeniør som er til stede.',
            editMainEngineer: 'Rediger hovedingeniør',
            errors: {
              creatingEngineer: 'Feil ved oppretting av ingeniør',
              creatingSession: 'Feil ved oppretting av økt',
            },
            header: 'Ingeniører på stedet',
            mainEngineer: 'Hovedingeniør',
            newAssistantEngineer: 'Skriv inn fullt navn',
            next: 'Neste',
            removeEngineer: 'Fjern ingeniør',
            selectExistingAssistantEngineer: 'Begynn å skrive navnet deres',
          },
          index: {
            description:
              'Av sikkerhetsgrunner, vennligst spesifiser navnene på hver ingeniør som er til stede.',
            errorCreatingEngineer: 'Feil ved oppretting av ingeniør, vennligst prøv igjen.',
            header: 'Ingeniører på stedet',
            hintMainEngineer: 'Skriv inn hovedingeniørens fullt navn',
            newMainEngineer: 'Ny hovedingeniør',
            next: 'Neste',
            selectExistingMainEngineer: 'Velg en eksisterende hovedingeniør',
            yes: 'Ja',
            no: 'Nei',
            mainEngineerLabel: 'Er du hovedingeniøren?',
          },
        },
        index: {
          callUsOn: 'Ring oss på {phoneNumber}',
          description: 'Finner du ikke det du leter etter?',
          dueBy: 'Forfallsdato',
          header: 'Velg arbeidsordre',
          notAvailable: 'Ikke tilgjengelig',
          searchWorkOrders: 'Søk i arbeidsordrer...',
        },
        manageEngineers: {
          manageEngineers: 'Administrer ingeniører',
          notWorking: 'Inaktive arbeidere',
          pause: 'Pause',
          resume: 'Gjenoppta',
          workingNow: 'Aktive arbeidere',
          startTime: 'Starttid',
          endTime: 'Sluttid',
          duration: 'Varighet',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Tilbakemelding',
            feedbackDescription:
              'Vennligst gi tilbakemelding på arbeidsordren for å hjelpe oss med å forbedre tjenestene våre.',
            feedbackLabel: 'Tilbakemelding',
            filesLabel: 'Vedlegg',
            submissionLabel: 'Send tilbakemelding',
          },
          hazards: {
            back: 'Gå tilbake',
            hazards: 'Farlige forhold',
            next: 'Neste',
            no: 'Nei',
            noTasksForHazard: 'Det er ingen oppgaver å fullføre for denne faren.',
            yes: 'Ja',
          },
          induction: {
            continue: 'Fortsett',
            induction: 'Introduksjon',
          },
          index: {
            checkIn: 'Sjekk inn',
            description: 'Vennligst fyll ut følgende risikovurdering for det valgte arbeidet.',
            fail: 'Feil ved behandling av start arbeidsordre sjekker.',
            haltMessage:
              'Potensielle risikoer oppdaget. Vennligst stopp arbeidet, gjennomgå sikkerhetsretningslinjene, og kontakt veilederen din for videre instruksjoner.',
            header: 'Sjekk av arbeidsforhold',
            endVisit: 'Avslutt besøk',
            leaveFeedback: 'Gi tilbakemelding',
          },
          safeToProceed: {
            continue: 'Fortsett',
            safeToProceed: 'Sikkert å fortsette',
          },
        },
      },
    },
    index: {
      title: 'Velkommen',
      description: 'Skann QR-koden på stedet ditt for å komme i gang.',
    },
    login: {
      errorTitle: 'Uventet feil',
      errorMessage: 'En uventet feil oppstod. Vennligst prøv å skanne QR-koden igjen.',
    },
    unauthenticated: {
      welcome: {
        title: 'Velkommen til {site}',
        description:
          'Før vi kan vise deg noen arbeidsordrer, må vi verifisere detaljene dine. Klikk på knappen nedenfor for å fortsette.',
        next: 'Fortsett',
      },
      index: {
        errorTitle: 'Uventet feil',
        errorMessage: 'En uventet feil oppstod. Vennligst prøv å skanne QR-koden igjen.',
      },
      contractor: {
        title: 'Hvem jobber du for?',
        contractor: 'Entreprenør',
        contractorLabel: 'Begynn å skrive navnet på selskapet ditt',
        contractorHint: 'Du må skrive inn 3 tegn eller mer for å se resultater',
        defaultSelectPlaceholder: '--Vennligst velg--',
        next: 'Neste',
      },
      user: {
        title: 'Hvem er du?',
        cancel: 'Avbryt',
        createNewUserLabel: 'Navnet mitt er ikke oppført',
        existingUserLabel: 'Begynn å skrive navnet ditt',
        existingUserHint: 'Du må skrive inn 3 tegn eller mer for å se resultater',
        newUserLabel: 'Skriv inn ditt fulle navn',
        next: 'Neste',
        user: 'Bruker',
      },
      verification: {
        methods: {
          add: {
            add: 'Legg til verifiseringsmetode',
            defaultSelectPlaceholder: '--Vennligst velg--',
            emailLabel: 'E-post',
            existingMethodWarning:
              'Du har allerede en ventende forespørsel om denne verifiseringsmetoden som venter på administrativ godkjenning. Å legge til en ny vil overstyre den.',
            method: 'Metode',
            methodLabel: 'Metode',
            mobileCountryHint: 'Vennligst velg landskode',
            mobileCountryLabel: 'Landskode for mobil',
            mobileHint: 'Vennligst skriv inn mobilnummeret ditt',
            mobileLabel: 'Mobil',
            title: 'Legg til verifiseringsmetode',
          },
          confirm: {
            confirm: 'Bekreft',
            description: 'Vennligst bekreft verifiseringsmetoden din for å fortsette.',
            label: 'Skriv inn koden din',
            resend: 'Send på nytt',
            resendPrompt: 'Mottok du ikke en kode?',
            title: 'Bekreft verifiseringsmetode',
          },
          confirmed: {
            description:
              'Du vil bli varslet når denne verifiseringsmetoden har blitt godkjent av administratoren din, og du kan da begynne å bruke den til å verifisere identiteten din.',
            forceApproval: 'Inntil den er godkjent, kan du ikke få tilgang til arbeidsordrene.',
            nonForceApproval:
              'I mellomtiden kan du fortsette å få tilgang til arbeidsordrene med redusert tilgang.',
            nonForceApprovalButtonLabel: 'Fortsett med redusert tilgang',
            title: 'Venter på godkjenning',
          },
          addNew: 'Legg til ny verifiseringsmetode',
          description:
            'Vi må verifisere identiteten din for å gi deg full tilgang til arbeidsordren.',
          email: 'E-post',
          hint: 'Vi sender en lenke til den valgte verifiseringsmetoden som gir deg full tilgang til arbeidsordren. Hvis du trenger å endre noen eksisterende verifiseringsmetoder, vennligst kontakt administratoren din.',
          label: 'Velg en verifiseringsmetode',
          next: 'Neste',
          pendingHint: 'Venter på godkjenning fra administratoren din',
          sms: 'SMS',
          title: 'Verifisering',
        },
        optional: {
          hint: 'Verifisering av brukeropplysningene dine vil gi deg full tilgang til arbeidsordren',
          label: 'Ønsker du å verifisere brukeropplysningene dine?',
          next: 'Neste',
          no: 'Nei',
          noHint:
            'Jeg ønsker ikke å verifisere brukeropplysningene mine og fortsette med redusert tilgang til arbeidsordren',
          title: 'Verifisering',
          yes: 'Ja',
          yesHint:
            'Jeg ønsker å verifisere brukeropplysningene mine og få full tilgang til arbeidsordren',
        },
        sent: {
          description:
            'En påloggingslenke har blitt sendt til {identifier}. Vennligst klikk på lenken for å fullføre påloggingen din.',
          title: 'Påloggingslenke sendt',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'I går',
      today: 'I dag',
      days: {
        monday: 'Mandag',
        tuesday: 'Tirsdag',
        wednesday: 'Onsdag',
        thursday: 'Torsdag',
        friday: 'Fredag',
        saturday: 'Lørdag',
        sunday: 'Søndag',
      },
      months: {
        january: 'Januar',
        february: 'Februar',
        march: 'Mars',
        april: 'April',
        may: 'Mai',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Desember',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Noe gikk galt',
      message: 'Vennligst prøv å skanne QR-koden igjen.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Ukjent bruker',
      },
      none: 'Ingen',
      types: {
        stateTransition: 'Status endret',
        contractorAssigned: 'Entreprenør tildelt',
        engineerAssigned: 'Ingeniør tildelt',
        serviceAssigned: 'Tjeneste tildelt',
        priorityChanged: 'Prioritet endret',
        actionableDateChanged: 'Handlingsbar dato endret',
        dueDateChanged: 'Forfallsdato endret',
        etaDateChanged: 'Estimert ankomstdato endret',
        spendLimitApproved: 'Utgiftsgrense godkjent',
        spendLimitCancelled: 'Utgiftsgrense forespørsel kansellert',
        spendLimitRejected: 'Utgiftsgrense avvist',
        spendLimitRequested: 'Utgiftsgrense forespurt',
        jobSheetUploaded: 'Jobbseddel lastet opp',
        slaAlertSent: 'Tid for å delta brutt SLA-varsel',
        issuedWorkPermit: 'Arbeidstillatelse utstedt',
        requestForServiceSent: 'Forespørsel om tjeneste sendt',
        comment: 'Kommentar lagt til',
        unknown: 'Ukjent hendelse',
      },
      labels: {
        actionableDate: 'Handlingsbar dato',
        comment: 'Kommentar',
        file: 'Fil',
        contractor: 'Entreprenør',
        dueDate: 'Forfallsdato',
        etaDate: 'Estimert ankomstdato',
        engineer: 'Ingeniør',
        priority: 'Prioritet',
        requestForService: 'Forespørsel om tjeneste',
        service: 'Tjeneste',
        spendLimit: 'Utgiftsgrense',
        status: 'Status',
        workPermit: 'Arbeidstillatelse',
      },
    },
  },
}
